import {library} from '@fortawesome/fontawesome-svg-core'
// We're doing imports like this because I can't get treeshaking to work when importing
// from the main package. The whole icon set is huge, almost a Mb, so we want to treeshake these.
// Solid Icons
import {faAngleRight} from '@fortawesome/free-solid-svg-icons/faAngleRight'
import {faBan} from '@fortawesome/free-solid-svg-icons/faBan'
import {faCaretDown} from '@fortawesome/free-solid-svg-icons/faCaretDown'
import {faCaretRight} from '@fortawesome/free-solid-svg-icons/faCaretRight'
import {faCheck} from '@fortawesome/free-solid-svg-icons/faCheck'
import {faChevronDown} from '@fortawesome/free-solid-svg-icons/faChevronDown'
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons/faChevronLeft'
import {faChevronRight} from '@fortawesome/free-solid-svg-icons/faChevronRight'
import {faCog} from '@fortawesome/free-solid-svg-icons/faCog'
import {faCopy} from '@fortawesome/free-solid-svg-icons/faCopy'
import {faCrosshairs} from '@fortawesome/free-solid-svg-icons/faCrosshairs'
import {faDownload} from '@fortawesome/free-solid-svg-icons/faDownload'
import {faEdit} from '@fortawesome/free-solid-svg-icons/faEdit'
import {faEllipsisH} from '@fortawesome/free-solid-svg-icons/faEllipsisH'
import {faEllipsisV} from '@fortawesome/free-solid-svg-icons/faEllipsisV'
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt'
import {faFilter} from '@fortawesome/free-solid-svg-icons/faFilter'
import {faGlobeAmericas} from '@fortawesome/free-solid-svg-icons/faGlobeAmericas'
import {faHdd} from '@fortawesome/free-solid-svg-icons/faHdd'
import {faHome} from '@fortawesome/free-solid-svg-icons/faHome'
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons/faInfoCircle'
import {faLongArrowAltDown} from '@fortawesome/free-solid-svg-icons/faLongArrowAltDown'
import {faLongArrowAltUp} from '@fortawesome/free-solid-svg-icons/faLongArrowAltUp'
import {faPlus} from '@fortawesome/free-solid-svg-icons/faPlus'
import {faSearch} from '@fortawesome/free-solid-svg-icons/faSearch'
import {faSearchLocation} from '@fortawesome/free-solid-svg-icons/faSearchLocation'
import {faShieldAlt} from '@fortawesome/free-solid-svg-icons/faShieldAlt'
import {faSignOutAlt} from '@fortawesome/free-solid-svg-icons/faSignOutAlt'
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes'
import {faTrash} from '@fortawesome/free-solid-svg-icons/faTrash'
import {faUser} from '@fortawesome/free-solid-svg-icons/faUser'
import {faUserEdit} from '@fortawesome/free-solid-svg-icons/faUserEdit'

// Regular Icons
import {faCalendarCheck} from '@fortawesome/free-regular-svg-icons/faCalendarCheck'
import {faQuestionCircle} from '@fortawesome/free-regular-svg-icons/faQuestionCircle'

// Every icon that's used in the app needs to be added here.
// This way, the icons are tree shaken, so we only include the ones we need.
export function init() {
    // Solid
    library.add(
        faBan,
        faCaretDown,
        faCaretRight,
        faCheck,
        faChevronDown,
        faChevronLeft,
        faChevronRight,
        faCog,
        faCopy,
        faCrosshairs,
        faDownload,
        faEdit,
        faEllipsisH,
        faEllipsisV,
        faExclamationTriangle,
        faExternalLinkAlt,
        faFilter,
        faGlobeAmericas,
        faHdd,
        faHome,
        faInfoCircle,
        faLongArrowAltDown,
        faLongArrowAltUp,
        faPlus,
        faSearch,
        faSearchLocation,
        faShieldAlt,
        faSignOutAlt,
        faTimes,
        faTrash,
        faUser,
        faUserEdit,
        faAngleRight,
    );
    // Regular
    library.add(
        faCalendarCheck,
        faQuestionCircle,
    );
}